<template>
  <div class="login">
    <div class="login-form">
      <div class="login-title">
        <!-- <img class="logo" src="/image/hy_logo.png" alt="" /> -->
        <img
          class="logo"
          :src="
            versionConfig.ZHIYUN_VERSION
              ? `/image/${
                  appConfig.logo_sm ? appConfig.logo_sm : 'zy_logo_sm.png'
                }`
              : '/image/hy_logo.png'
          "
        />

        <p v-if="versionConfig.ZHIYUN_VERSION">
          <span v-if="appConfig.slogan">{{ appConfig.slogan }}</span>
          <span v-else>智慧领航&nbsp; 云享未来</span>
        </p>
        <p v-else>高效运营&nbsp; 宾客如云</p>
      </div>
      <van-cell-group>
        <van-field
          v-model="companyId"
          required
          clearable
          label="酒店编码"
          placeholder="请输入酒店编码"
        />

        <van-field
          v-model="username"
          required
          clearable
          label="用户名"
          placeholder="请输入用户名"
        />

        <van-field
          v-model="password"
          type="password"
          label="密码"
          placeholder="请输入密码"
        />
      </van-cell-group>
      <div>
        <van-checkbox
          class="remember"
          v-model="checked"
          shape="square"
          icon-size="18px"
          >记住密码</van-checkbox
        >
      </div>
      <van-button style="margin-top:20px;" type="info" block @click="Login()"
        >确认登录</van-button
      >

      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="shiftsArr"
          value-key="Name"
          @cancel="showPicker = false"
          @confirm="onConfirmShifts"
        />
      </van-popup>
      <div class="copyright">
        {{ appConfig.copyRight ? appConfig.copyRight : "Copyright ©2019" }}
        {{
          versionConfig.ZHIYUN_VERSION
            ? appConfig.title
              ? appConfig.title
              : "智云Plus"
            : "鸿云"
        }}住宿管理系统
        <span style="margin-left:10px">版本号：{{ version }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { login, setShift, getVersionNo } from "@/api/auth.js";
import {
  Button,
  CellGroup,
  Field,
  Notify,
  Popup,
  Picker,
  Checkbox,
  CheckboxGroup,
} from "vant";
import md5 from "js-md5";
import { mapState, mapActions } from "vuex";
import { ls } from "@/utils/cache.js";
import authLoginModal from "@/components/authLogin";
import store from "@/store/";
export default {
  name: "home",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      versionConfig,
      username: "",
      password: "",
      companyId: "",
      showPicker: false,
      shiftsArr: [],
      version: "",
      checked: false,
    };
  },
  computed: {
    ...mapState({
      appConfig: state => state.app.appConfig,
      user: state => state.user.info,
    }),
  },
  created() {
    getVersionNo().then(res => {
      this.version = res.Data;
    });
    const remember = ls.get("userinfo_remember");
    if (remember) {
      this.companyId = remember.CompanyCode;
      this.username = remember.Account;
      this.password = remember.Password;
      this.checked = true;
    }
  },
  methods: {
    ...mapActions(["setUserInfo"]),
    Login() {
      if (!this.username || !this.companyId) {
        Notify("请输入酒店编码、登录账号！");
        return false;
      }
      ls.remove("LogInfo");
      const json = {
        Account: this.username,
        CompanyCode: this.companyId,
      };
      let password = "";
      if (this.password) {
        password = md5(this.password);
      }
      let params = {
        Account: this.username,
        Password: password,
        CompanyCode: this.companyId,
      };
      login(params).then(res => {
        // if (this.username.toLowerCase() == "superadmin") {
        //   authLoginModal({
        //     token: res.Data.Token,
        //     loginParams: params,
        //     companyCode: this.companyId,
        //     submit: () => {
        //       this.onLoginAfter(res, json);
        //     },
        //   });
        // } else {
        this.onLoginAfter(res, json);
        // }
      });
    },
    onLoginAfter(res, json) {
      this.setUserInfo(res.Data);
      ls.set("LogInfo", {
        ...json,
        Password: this.password,
      });
      if (this.checked) {
        ls.set("userinfo_remember", {
          ...json,
          Password: this.password,
        });
      } else {
        ls.remove("userinfo_remember");
      }
      this.$nextTick(() => {
        this.shiftsArr = res.Data.Shifts;
        let jumpName = this.getJumpName();
        if (this.shiftsArr == "" || !this.shiftsArr.length) {
          const indexPage = res.Data.IsGroupSystem ? "groupIndex" : jumpName;
          this.$router.push({ name: indexPage });
        } else {
          this.showPicker = true;
        }
      });
    },
    getJumpName() {
      let code = "GuestRoom",
        jumpName = "TodayRoom";
      const defaultMenu = this.user.Menus.find(p => p.Code == code);
      if (defaultMenu) {
        const item = defaultMenu.Childs[0];
        if (item.Code == "TodayRoomStatus") {
          jumpName = "TodayRoom";
        } else if (item.Code == "FutureRoomStateManage") {
          jumpName = "RoomStatus";
        } else {
          jumpName = "workplace";
        }
      } else {
        jumpName = "workplace";
      }
      return jumpName;
    },
    onConfirmShifts(value) {
      let jumpName = this.getJumpName();

      setShift(value).then(() => {
        this.$router.push({ name: jumpName });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  background: #f1f1f1;
  height: 100vh;
  top: 0;
  position: fixed;
  display: block;
  width: 100%;
  &-form {
    width: 100%;
    background: #fff;
    padding: 15% 5% 5%;
    height: 100%;
    position: relative;
    .login-title {
      font-size: 18px;
      text-align: center;
      margin-bottom: 20px;
      .logo {
        width: 42%;
        display: block;
        margin: 0 auto;
      }
      p {
        color: #999;
        font-size: 16px;
        margin: 10px 0 30px;
      }
    }
    .remember {
      float: right;
      margin: 15px 0 20px;
      /deep/.van-checkbox__label {
        color: #0071e9;
        font-size: 14px;
      }
    }
    .copyright {
      position: fixed;
      bottom: 10px;
      left: 0;
      text-align: center;
      color: #999;
      font-size: 12px;
      width: 100%;
    }
  }
}
</style>
